export default {
  callFlowTrees: [],
  callFlowTree: {},
  availableNodes: [],
  availableTags: [],
  availableTemplates: [],
  availableVoices: [],
  callFlowTreeReferences: {},
  status: {},
  sceneErrors: [],
  bulkTagUploads: [],
  searchTagExists: null,

  /**
   * @type {string}
   */
  newUploadedBulkTagId: null,
  /**
   * @type {string}
   */
  newTextToSpeechRecordingId: null,
  /**
   * @type {string}
   */
  newTextToSpeechRecordingUrl: null,

  /**
   * @type {boolean}
   */
  isDuplicate: false,
  /**
   * @type {string}
   */
  uploadedFileName: ''
};
